/* eslint-disable no-unused-vars */
import { checkCurrentToken, getAll } from '../../api';
import router from '../../router';

// initial users state
const state = {
  loggedIn: false,
  currentUser: {},
  error: null,
  success: false,
};

// getters
const getters = {
  getIsLoggedIn: (state) => state.loggedIn,
  getCurentCognitoUser: (state) => state.currentUser,
  getError: (state) => state.error,
  getSuccess: (state) => state.success,
};

const actions = {
  logOut: async ({ commit, dispatch }) => {
    dispatch('localStore/removeToken', true, { root: true });
    commit('setLogStatus', false);
    commit('account/setCurrentClient', null, { root: true });
    commit('setClientLogo', null, { root: true });
    localStorage.removeItem('currentClient');
    localStorage.removeItem('auth');
    // signOut();
  },
  logIn: async ({ commit, dispatch }, payload) => new Promise((resolve, reject) => {
    if (payload.auth) {
      dispatch('account/getUserData', payload.auth, {
        root: true,
      })
        .then((res) => {
          if (res.data.data.auth.email) {
            commit('setCurrentUser', res);
            localStorage.setItem('auth', JSON.stringify(res.data.data));
            // if (res.challengeName === "NEW_PASSWORD_REQUIRED") {
            //   router.push("/confirmaccount");
            // } else {
            commit('setLogStatus', true);
            // dispatch(
            //   "localStore/setToken",
            //   {
            //     name: "token",
            //     value: res.signInUserSession.accessToken.jwtToken
            //   },
            //   { root: true }
            // );
            dispatch('account/getAllClients', '', { root: true });
            resolve(res);
            // }
          } else {
            commit('setError', res.message);
            reject(res);
          }
        })
        .catch((error) => {
          commit('setError', error);
          reject(error);
        });
    } else {
      dispatch('account/getUserData', payload, {
        root: true,
      })
        .then((res) => {
          if (res.data.data.auth.email) {
            commit('setCurrentUser', res);
            localStorage.setItem('auth', JSON.stringify(res.data.data));
            // if (res.challengeName === "NEW_PASSWORD_REQUIRED") {
            //   router.push("/confirmaccount");
            // } else {
            commit('setLogStatus', true);
            // dispatch(
            //   "localStore/setToken",
            //   {
            //     name: "token",
            //     value: res.signInUserSession.accessToken.jwtToken
            //   },
            //   { root: true }
            // );
            dispatch('account/getAllClients', '', { root: true });
            resolve(res);

            // }
          } else {
            commit('setError', res);
            reject(res);
          }
        })
        .catch((error) => {
          commit('setError', error);
          reject(error);
        });
    }
  }),
  completeSignUp: async ({ commit, dispatch }, payload) => new Promise((resolve, reject) => {
    getAll(
      `/user?query=${
        encodeURIComponent(
          `mutation{update(type_name: "user", user:${payload.data}){user_name}}`,
        )}`,
    )
      .then((res) => {
        commit('setLogStatus', true);
        dispatch('account/getAllClients', '', { root: true });
        commit('setError', null);
        resolve(res);
      })
      .catch((error) => {
        commit('setError', error.message);
        reject(error);
      });
  }),
  initialSignUp: async ({ commit, dispatch }, payload) => new Promise((resolve, reject) => {
    getAll(
      `/user?query=${
        encodeURIComponent(
          `{invite(user:{email: "${payload.email}", type_name: "${payload.type}", client_id: ["${payload.client}"], location: "${payload.location}", group_id: ["${payload.group_id}"]}){email, type_name, client_id, uuid, location, success, error}}`,
        )}`,
    )
      .then((res) => {
        if (res.data.data.invite.error) {
          commit('setError', res.data.data.invite.error);
        } else {
          commit('setError', 'Invite Sent');
          dispatch('account/getAllUsers', null, { root: true });
        }
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  }),
  checkToken: async ({
    commit, dispatch, state, rootGetters,
  }) => {
    if (!state.loggedIn && localStorage.getItem('token')) {
      try {
        const res = await checkCurrentToken();
        commit('setLogStatus', true);
        dispatch(
          'localStore/setToken',
          {
            name: 'token',
            value: res.accessToken.jwtToken,
          },
          { root: true },
        );
        dispatch('account/getAllClients', '', { root: true });
      } catch (err) {
        localStorage.removeItem('token');
      }
    } else if (state.loggedIn && router.history.current.name === 'Login') {
      dispatch('account/getAllClients', '', { root: true });
    }
  },
  forgotPassword: async ({ dispatch, commit }, payload) => new Promise((resolve, reject) => {
    getAll(
      `/user?query=${
        encodeURIComponent(
          `{request_reset(user:{email: "${payload}"}){user_name}}`,
        )}`,
    )
      .then((res) => {
        commit('setSuccess', true);
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  }),
  changePassword: async ({ dispatch, commit }, payload) => new Promise((resolve, reject) => {
    getAll(
      `/user?query=${
        encodeURIComponent(
          `{reset_password(user:{email: "${payload.email}", password: "${payload.password}", password_code: "${payload.code}"}){user_name}}`,
        )}`,
    )
      .then((res) => {
        commit('setSuccess', true);
        resolve(res);
      })
      .catch((error) => {
        commit('setError', error.message);
        reject(error);
      });
  }),
};

const mutations = {
  setLogStatus(state, payload) {
    state.loggedIn = payload;
  },
  setError(state, payload) {
    state.error = payload;
  },
  setSuccess(state, payload) {
    state.success = payload;
  },
  setCurrentUser(state, payload) {
    state.currentUser = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
